import { useNotificationStore } from "../../Store/NotificationStore";
import styles from "./NotificationWrapper.module.css";

import { motion, AnimatePresence } from "framer-motion";

import Notification from "./Notification";

export default function NotificationWrapper() {
  const showNotification = useNotificationStore(
    (state) => state.showNotification
  );

  return (
    <div className={styles.container}>
      <AnimatePresence>
        {showNotification && (
          <motion.div
            className={styles.wrapper}
            initial={{ opacity: 0, y: -50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -50 }}
            transition={{
              type: "spring",
              stiffness: 200,
              damping: 20,
            }}
          >
            <Notification />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
